import { render } from "./Product.vue?vue&type=template&id=2b978b0c"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"
script.render = render

export default script